import {
  set, action, observable, computed,
} from 'mobx';
import CartItem, { ICartItem, SKU_TYPE } from './CartItem';
import Constants from '../../../constants/Constants';
import CartItemUtils from '../../../utils/CartItemUtils';

export interface ICart {
  cartItems: ICartItem[];
}

export default class Cart {
  @observable cartItems: CartItem[] = [];

  static fromJSON(data: ICart): Cart {
    const cart = new Cart();
    const cartItems = data.cartItems.map((item: ICartItem) => CartItem.fromJSON(item));
    set(cart, { cartItems });

    return cart;
  }

  @action
  update(data: Cart): void {
    set(this.cartItems, data.cartItems);
  }

  @computed
  get shipGroupedCartItems(): Map<string, CartItem[]> {
    if (this.cartItems.some(item => item.estimatedDeliveryDate)) {
      return CartItemUtils.groupCartItemsByField(this.cartItems, 'estimatedDeliveryDate', Constants.NO_DATE_CART_ITEM);
    } 
    return null;
  }

  @computed
  get donationItems(): CartItem[] {
    return this.cartItems
      .filter((item: CartItem) => item.skuType === SKU_TYPE.Donation);
  }

  get isAnyItemAutoReplenish(): boolean {
    return this.cartItems.some(({ isAutoReplenish }) => isAutoReplenish);
  }

  @computed
  get isSampleInCart(): boolean {
    return this.cartItems.some(({ isSampleItem }) => isSampleItem);
  }

  @computed get GiftWrapItem(): CartItem {
    return this.cartItems.find(item => item.skuType === SKU_TYPE.GiftWrap);
  }

  @computed get hasGiftWrapItem(): boolean {
    return this.cartItems.some(item => item.skuType === SKU_TYPE.GiftWrap);
  }

  @computed get hazmatItemNames(): string[] {
    return this.cartItems.filter(item => item.isHazmat)
      .map(( { productRgnName } ) => productRgnName );
  }
}
